import api from "../utils/api";
const API_URL = process.env.REACT_APP_API_URL;

export const getProjects = async () => {
  const response = await api.post(
    `${API_URL}/projects.php`,
    { action: "getAll" },
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
  return response.data.projects || [];
};

export const getProjectById = async (id) => {
  const response = await api.post(
    `${API_URL}/projects.php`,
    { id: id, action: "get" },
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
  return response.data.project;
};

export const updateProject = async (id, projectData) => {
  const response = await api.post(
    `${API_URL}/projects.php`,
    { ...projectData, action: "update", id },
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
  return response.data;
};
